import exportFromJSON from './exportFromJSON.js';
export default exportFromJSON;



//////////////////
// WEBPACK FOOTER
// ./~/export-from-json/dist/esm/index.js
// module id = 297
// module chunks = 0